export default __webpack_public_path__ + "1a879bacf392219a8792e85ffc586b27.png";